<style lang="scss" scoped>
@import '../../styles/helpers/main';
@import '../../styles/vars/main';
.settings {
  max-width: 800px;
  display: flex;
  flex-direction: column;
  height: 100%;
  &__block {
    margin-bottom: space('extravaganty')
  }
  &__subline {
    margin-top: space('skinny');
  }
  &__max-dim {
    margin-top: space('narrow');
  }
  &__info {
    background-color: color('info');
    padding: space('narrow');
  }
  &__footer {
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;
  }
  &__add {
    margin-top: space('narrow');
  }
}

.max-dim {
  display: flex;
  align-items: center;
  &__label {
    width: 100px;
    font-weight: 500;
  }
  &__input-wrapper{
    position: relative;
    display: flex;
    align-items: center;
    width: 80px;
  }
  &__input-dim{
    position: absolute;
    right: space('skinny');
    color: color('grey', 'darkest');
    font-size: font-size('deci');
    user-select: none;
  }
  &__input {
    width: 80px;
    -webkit-appearance: none;
    text-align: center;
    padding: space('tight');
  }
}

.small {
  margin-left: space('skinny');
  color: color('grey', 'darkest');
  font-size: font-size('deci');
}

.delete {
  svg{
    @include svg-dim("base");
  }
}

.sizes {
  margin-top: space('narrow');
  &__header {
    display: flex;
    font-weight: 500;
    margin-bottom: space('narrow');
    span {
      width: 150px;
    }
  }
  &__row {

  }
  &__row + &__row {
    margin-top: space('tight');
  }
  &__form {
    display: flex;
  }
  &__input {
    width: 150px;
    p {
      position: relative;
      width: 80px;
      display: flex;
      align-items: center;
    }
  }
  &__add {
    margin-top: space('narrow');
    svg{
      @include svg-dim("base");
    }
  }
  &__add-label {
    margin-left: space('skinny');
    color: color('grey', 'darkest');
    font-size: font-size('deci');
  }
  &__error {
    color: color('warning');
    font-weight: 500px;
    margin-bottom: space('narrow');
  }
  .error {
    border: solid 1px color('warning');
  }
}

</style>
<template>
  <div class="settings">
    <div class="settings__block">
      <v-headline :level="'1'" cssClass="--nile edit__headline">Settings</v-headline>
      <p class="settings__subline">Whenever you are uploading images this settings will be used.</p>
    </div>
    <div class="settings__block u-h-full">
      <v-headline :level="'2'" cssClass="edit__headline --black">Create additional image sizes</v-headline>
      <p class="settings__subline">To avoid downloading unnecessary large images, you can create images in various dimensions, to fit best for different device sizes. If aspect ratio is selected, depending on the image format (landscapce or portrait), the height or the width will be taken to calculate the other side length. If aspect ratio is not selected witdh and height will be taken to crop the image.</p>

      <div class="sizes">
        <div v-show="sizes != 0">
          <div class="sizes__header">
            <span>prefix</span>
            <span>aspect ratio</span>
            <span>width</span>
            <span>height</span>
          </div>
          <div class="sizes__row" v-for="(item, index) in sizes" :key="item.id">
            <div class="sizes__form">
              <p class="sizes__input">
                {{item.prefix}}
              </p>
              <p class="sizes__input">
                {{ item.keepRatio == 1 ? 'true' : 'false'}}
              </p>
              <p class="sizes__input">
                {{item.width}}
                <span class="small">px</span>
                <span v-show="item.keepRatio == 1" class="small">- max</span>
              </p>
              <p class="sizes__input">
                {{item.height}}
                <span class="small">px</span>
                <span v-show="item.keepRatio == 1" class="small">- max</span>
              </p>
              <v-button class="button-circle --grey delete" @click.prevent="deleteItem(index, item.id)">
                <svg>
                  <use xlink:href="#delete"></use>
                </svg>
              </v-button>
            </div>
          </div>
            <!--  :data-vv-scope="item.id" -->
            <!-- <div class="sizes__errors">
              <p v-show="errors.has(`prefix${index}`)" class="sizes__error help is-danger">{{ errors.first(`prefix${index}`) }}</p>
            </div>
            <div class="sizes__form">
              <p class="sizes__input">
                <input
                  key = "prefix"
                  type = "text"
                  :name = "`prefix${index}`"
                  class = "textfield max-dim__input"
                  v-model = "item.prefix"
                  maxlength = "8"
                  autocomplete = "off"
                  v-validate  = "{ required: true, unique: { unique: focusedPrefix, list: filteredPrefixes} }"
                  :class = "{'error': errors.has(`prefix${index}`)}"
                  @focus = "filterSizes(index)"
                  @keyup = "setPrefix()"
                >
              </p>
              <p class="sizes__input">
                <input class="checkbox" type="checkbox" :id="`ratio${index}`">
                <label :for="`ratio${index}`">Yes</label>
              </p>
              <div class="sizes__input">
                <p>
                  <span class="max-dim__input-dim">px</span>
                  <input
                    key = "width"
                    type="text"
                    :name="`width${index}`"
                    v-model="item.width"
                    class="textfield max-dim__input"
                    maxlength="4"
                    autocomplete="off"
                    v-validate="{ required: true, numeric: true }"
                    :class="{'error': errors.has(`width${index}`)}"
                  >
                </p>
              </div>
              <div class="sizes__input">
                <p>
                  <span class="max-dim__input-dim">px</span>
                  <input
                    key = "height"
                    type="text"
                    :name="`height${index}`"
                    v-model="item.height"
                    class="textfield max-dim__input"
                    maxlength="4"
                    autocomplete="off"
                    v-validate="{ required: true, numeric: true }"
                    :class="{'error': errors.has(`height${index}`)}"
                  >
                </p>
              </div>
            </div> -->
        </div>
        <div class="settings__add">
            <v-headline :level="'4'" cssClass="sizes__header --black">Add new Size</v-headline>
            <div>
              <p v-show="errors.has('requiredSummary')" class="sizes__error help is-danger">{{ errors.first('requiredSummary') }}</p>
              <p v-show="errors.has('prefixName:unique')" class="sizes__error help is-danger">{{ errors.first('prefixName') }}</p>
            </div>
            <div class="sizes__form">
              <p class="sizes__input">
                <input
                  type = "text"
                  name = "prefixName"
                  class = "textfield max-dim__input"
                  v-model = "newSize.prefix"
                  maxlength = "8"
                  autocomplete = "off"
                  v-validate  = "{ required: true, unique: prefixes }"
                  :class = "{'error': errors.has('prefixName')}"
                >
              </p>
              <p class="sizes__input">
                <input
                  v-model = "newSize.keepRatio"
                  class="checkbox"
                  type="checkbox"
                  id="kepRatio"
                >
                <label for="kepRatio" class="checkbox-label">Yes</label>
              </p>
              <p class="sizes__input">
                <input
                  type = "text"
                  name = "width"
                  class = "textfield max-dim__input"
                  v-model = "newSize.width"
                  maxlength = "4"
                  autocomplete = "off"
                  v-validate  = "{ required: true }"
                  :class = "{'error': errors.has('width')}"
                >
              </p>
              <p class="sizes__input">
                <input
                  type = "text"
                  name = "height"
                  class = "textfield max-dim__input"
                  v-model = "newSize.height"
                  maxlength = "4"
                  autocomplete = "off"
                  v-validate  = "{ required: true }"
                  :class = "{'error': errors.has('height')}"
                >
              </p>
            </div>
          </div>
       <!--  <div class="sizes__add" >
          <v-button class="button-circle --grey overlay__close" @click.prevent="addSize">
            <svg>
              <use xlink:href="#add"></use>
            </svg>
          </v-button>
           <span class="sizes__add-label">Add additional image size.</span>
        </div> -->
      </div>
    </div>
    <div class="settings__footer">
      <v-button cssClass="button --secondary" @click="cancel">Abbrechen</v-button>
      <v-button @click="save">Speichern</v-button>
    </div>
  </div>
</template>
<script>
// imports
import { mapGetters } from 'vuex';
import Headline from '../headline';
import Textfield from '../textfield';
import Button from '../button';
import pluralSingular from '../../mixins/pluralSingular.js';
import Api from '@/apis/photos-api';

export default {
  // child components this component calls
  components: {
    'v-headline': Headline,
    'v-textfield': Textfield,
    'v-button': Button
  },
  // scoped variables in this component
  data () {
    return {
      sizes: [],
      newSize: {}
    };
  },
  // observed variables (by function)
  computed: {
    prefixes() {
      return this.sizes.map(item => {
        return item.prefix;
      });
    }
  },
  // global mixins used like methods
  mixins: [],
  // functions firing by template
  methods: {
    deleteItem(index, id) {
      Api.delete('imagesizes', id).then((resullt) => {
        this.sizes.splice(index, 1);
      });
    },
    save() {
      const newSizes = this.sizes.filter(item => {
        if (item.new === true) return item;
      });
      const updateSizes = this.sizes.filter(item => {
        if (item.new !== true) return item;
      });

      // for (let i = 1; i < this.sizes.length + 1; i++) {
        // this.$validator.validateAll(i).then((result) => {
      this.$validator.validateAll().then((result) => {
        if (result) {
          Api.create('imagesizes', this.newSize).then((resullt) => {
            this.sizes.push(this.newSize);
            this.resetForm();
          });
        } else {
          const message = this.$validator.dictionary.getMessage('de', 'requiredSummary');
          this.errors.add({
            // scope: i,
            scope: null,
            field: 'requiredSummary',
            msg: message
          });
        }
      });
      // }
    },
    resetForm() {
      this.$nextTick(() => {
        this.newSize = {};
        this.$validator.reset();
      });
    },
    cancel() {
      this.$store.commit('overlay_isOpen', false);
    }
  },
  // variables passed from parent template
  props: { },
  // Lifecycle hooks
  created () {
    Api.get('imagesizes').then((response) => {
      if (response.data.length !== 0) {
        this.sizes = response.data;
      }
    }).catch((error) => {
      console.log('error', error);
    });
  },
  mounted () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy() { },
  destroyed () { }
};
</script>



// WEBPACK FOOTER //
// src/components/album/settings.vue